/**
 * #1176 — only same-origin absolute paths survive: absolute and
 * protocol-relative URLs are dropped, and so is any value containing a C0
 * control character (tab, newline, carriage return, etc.), DEL, or a
 * backslash. The WHATWG URL parser strips those characters outright, so
 * e.g. `/\t/evil.example` resolves to `https://evil.example/`.
 */
const UNSAFE_CHARACTERS = /[\x00-\x1F\x7F\\]/;

export function safeRedirectPath(value: string | null): string | null {
  if (
    !value ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    value.startsWith('/\\') ||
    UNSAFE_CHARACTERS.test(value)
  ) {
    return null;
  }
  return value;
}
